import React from "react";
import { Instagram } from "lucide-react";
import { useApp } from "@/context/AppContext";

export const InstagramFeed = ({ social }) => {
  const { lang } = useApp();
  const posts = social?.posts || [];
  if (!posts.length) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-24" data-testid="instagram-section">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#16221D]">
            {lang === "es" ? "Últimas publicaciones" : "Latest posts"}
          </h2>
          <p className="mt-2 text-sm text-[#5E6D64]">
            {lang === "es" ? "Lo más reciente de nuestras salidas en Instagram" : "The latest from our trips on Instagram"}
          </p>
        </div>
        <a href={social.instagram_url} target="_blank" rel="noopener noreferrer" data-testid="instagram-follow-link"
          className="inline-flex items-center gap-2 rounded-full border border-[#6E7E56] text-[#6E7E56] px-5 py-2 text-sm hover:bg-[#6E7E56] hover:text-white transition-colors duration-300">
          <Instagram className="h-4 w-4" />
          {social.instagram_handle || "@zendahiking"}
        </a>
      </div>
      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {posts.slice(0, 6).map((code, i) => (
          <div key={code} data-testid={`instagram-post-${i}`}
            className="rounded-2xl overflow-hidden bg-white border border-[#E2DFD7] shadow-[0_8px_30px_rgb(0,0,0,0.05)]">
            <iframe
              title={`Instagram ${code}`}
              src={`https://www.instagram.com/p/${code}/embed/captioned/`}
              loading="lazy"
              scrolling="no"
              className="w-full h-[520px] border-0"
              allowtransparency="true"
            />
          </div>
        ))}
      </div>
    </section>
  );
};
